import { render, staticRenderFns } from "./StandingBlock.vue?vue&type=template&id=40edbdb4"
import script from "./StandingBlock.vue?vue&type=script&lang=ts"
export * from "./StandingBlock.vue?vue&type=script&lang=ts"
import style0 from "./StandingBlock.vue?vue&type=style&index=0&id=40edbdb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports